import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';

import { DynamicBarService } from '../../../_components/dynamic-bar/dynamic-bar.service';
import { CustomAlertService } from '../../../_components/custom-alert/custom-alert.service';
import { AsistenciaService } from '../_services/asistencia.service';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, combineLatest, Subject, Subscription } from 'rxjs';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { SingleCommentComponent } from '../../../_components/glm-comentarios/single-comment/single-comment.component';
import * as d3 from 'd3';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AsistenciaCursoService } from './asistencia-curso.service';
import { map } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { MY_FORMATS } from '../../../_models/moment-formats';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';

export interface CursoAsistencia {
  id: number;
  tipoID: number;
  alumnoID: number;
  materiaCursoPeriodoID: number;
  hora: number;
}

@Component({
  selector: 'citacion-materia-curso',
  standalone: false,
  templateUrl: 'asistencia-curso.component.html',
  styleUrls: [
    '../asistencia.component.scss',
    './asistencia-curso.component.scss',
    '../reporte-director-curso/reporte-director-curso.component.scss',
    '../../nivelaciones/citacion-materia-curso/citacion-materia-curso.component.scss'
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,

  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class AsistenciaCursoComponent {
  displayedColumns = ['Alumno', 'AusenciasAcumuladas']; // , 'InfoGeneral', 'Asistencia', 'Tarea', 'ObsTarea'];
  dataSource: MatTableDataSource<any>;
  sort: MatSort;
  tiposAsistencia: any;
  materiaCursoPeriodo: any;
  listPendientes: any[];


  private calendarConfigSubject = new Subject<any>();
  calendarConfigData$ = this.calendarConfigSubject.asObservable();
  listWarningDates = [];
  calendarData$ = combineLatest([
    this.asistenciaCursoService.listPendientes$,
    this.calendarConfigData$
  ])
    .pipe(
      map(([listPendientes, calendarData]) => {
        this.listWarningDates = listPendientes;
        return {
          listPendientes,
          fechaCalendar: calendarData.selectedDate,
          initialDate: calendarData.initialDate,
          endDate: calendarData.endDate
        };
      }),
    );

  fechaSeleccionada = this.route.snapshot.paramMap.get('fecha') ? this.route.snapshot.paramMap.get('fecha') : moment().format('YYYY-MM-DD');
  date = new UntypedFormControl(moment(this.fechaSeleccionada));



  private materiaSubject = new Subject<any>();
  materia$ = this.materiaSubject.asObservable()
    .pipe(
      map(data => {
        this.dynamicBarService.setBarra('barra-simple', {
          titulos: [
            { texto: 'Asistencia', link: [] },
            { texto: data.nombre, link: [] },
          ]
        });
        // this.dynamicBarService.setBarra('asistencia-curso-barra', { materiaCursoPeriodo: data });
        console.log('materia', data);
        this.titleService.setTitle(`Asistencia - ${data.nombre}`);
        this.calendarConfigSubject.next(
          {
            selectedDate: { mDate: moment(this.fechaSeleccionada), selected: true },
            initialDate: moment(data.periodo.fechaInicia.substring(0, 10), 'YYYY-MM-DD'),
            endDate: moment(data.periodo.fechaFin.substring(0, 10), 'YYYY-MM-DD')
          }
        );
        return data;
      })
    );

  private absentStudentListSubject = new BehaviorSubject([]);
  absentStudentList$ = this.absentStudentListSubject.asObservable();

  private studentsListSubject = new Subject<any>();
  studentList$ = this.studentsListSubject.asObservable();

  studentsListWithAssistance$ = combineLatest([
    this.materia$,
    this.studentList$,
    this.absentStudentList$
  ])
    .pipe(
      map(([materia, students, absentList]) => {
        return students.map(student => {
          const absentIndex = absentList.findIndex(absentStudent => absentStudent.alumno.id === student.alumno.id);
          if (absentIndex > -1) {
            student = JSON.parse(JSON.stringify(absentList[absentIndex]));
          }
          const holderAsist = student.asistencias;
          student.asistencias = [];
          for (let i = 0; i < materia.horasClase; i++) {
            student.asistencias.push({
              id: 0,
              tipoID: 0,
              alumnoID: student.alumno.id,
              materiaCursoPeriodoID: +this.mcpID,
              hora: student.asistencias.length + 1,
              fechaAsistencia: this.fechaSeleccionada,
              isEditable: true
            });
          }
          holderAsist.map(hAsist => {
            const indexAsist = student.asistencias.findIndex(currI => {
              return currI.hora === hAsist.hora;
            });
            student.asistencias[indexAsist] = hAsist;
          });
          return student;
        });
      })
    );

  private textFilterSubject = new BehaviorSubject('');
  textFilterAction$ = this.textFilterSubject.asObservable();

  filteredStudents$ = combineLatest([
    this.textFilterAction$,
    this.studentsListWithAssistance$
  ])
    .pipe(
      map(([textParam, students]) => students.filter(student => student.alumno.apellidosNombres.toLowerCase().indexOf(textParam) > -1))
    );

  mcpID: number | string;

  commentSub: Subscription;

  showSidebar = true;

  private rowStateSubject = new BehaviorSubject<any>({ label: 'Contraer', state: 'expanded' });
  rowStateAction$ = this.rowStateSubject.asObservable();

  dateClass(pendientes: any[]): MatCalendarCellClassFunction<Date> {
    // Normalizamos las fechas SOLO una vez
    const pendientesNormalizadas = (pendientes ?? []).map(p => {
      // Si el backend manda objetos { fecha: '2025-11-14' }
      const raw = p?.fecha ?? p;
      return moment(raw).format('YYYY-MM-DD');
    });

    return (cellDate: Date, view: 'month' | 'year' | 'multi-year') => {
      // Solo pintamos en la vista mensual
      if (view !== 'month' || !pendientesNormalizadas.length) {
        return '';
      }

      const cell = moment(cellDate).format('YYYY-MM-DD');

      return pendientesNormalizadas.includes(cell) ? 'warning-date' : '';
    };
  }



  constructor(private route: ActivatedRoute,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private dynamicBarService: DynamicBarService,
    private customAlertService: CustomAlertService,
    private asistenciaService: AsistenciaService,
    private asistenciaCursoService: AsistenciaCursoService,
    public dialog: MatDialog,
    private titleService: Title) {
    asistenciaCursoService.setUrlParams({ fecha: route.snapshot.paramMap.get('fecha'), mcpID: route.snapshot.paramMap.get('mcpID') });
    asistenciaCursoService.asistenciaCurso$.subscribe(data => {
      this.studentsListSubject.next(data['alumnos']);
      this.materiaSubject.next(data['materia']);
    }
    );

    this.tiposAsistencia = route.parent.snapshot.data['tiposAsistencia'];

    this.mcpID = +this.route.snapshot.paramMap.get('mcpID'); // TODO: Mejorar esto.

    router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  filtroTexto(filterValue: string) {
    this.textFilterSubject.next(filterValue.toLowerCase());
  }

  changeDate(date) {
    this.router.navigate(['/', 'asistencia', 'materia', this.mcpID, 'fecha', date.format('YYYY-MM-DD')]);
  }

  addHour(mcp) {
    mcp.horasClase++;
    this.asistenciaService.updateMCP(mcp).subscribe(res => {
      this.asistenciaService.signalToUpdateMCPList(this.mcpID, this.fechaSeleccionada).subscribe(res1 => {
        this.materiaSubject.next(mcp);
        this.absentStudentListSubject.next(this.asistenciaService.extractData(res1));
        this.snackBar.open(
          `Se ha agregado una hora a la clase`,
          null,
          { duration: 2500 }
        );
      });
    }, err => {
      mcp.horasClase--;
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `Se ha presentado un error agregando una hora a la clase. Inténtelo nuevamente. <br> Código de error: ${err.statusText}`
      });
    }, () => {
    });
  }

  removeHour(mcp) {
    if (confirm('Existen registros de asistencia. \n¿Está seguro que desea borrar horas de clase?')) {
      mcp.horasClase--;
      this.asistenciaService.updateMCP(mcp).subscribe(res => {
        this.asistenciaService.signalToUpdateMCPList(this.mcpID, this.fechaSeleccionada).subscribe(res1 => {
          this.materiaSubject.next(mcp);
          this.snackBar.open(
            `Se ha restado una hora a la clase`,
            null,
            { duration: 2500 }
          );
        });
      }, err => {
        mcp.horasClase++;
        this.cdRef.markForCheck();
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `Se ha presentado un error restando la hora. Inténtelo nuevamente. <br> Código de error: ${err.statusText}`
        });
      }, () => {
      });
    }
  }

  setAsistencia(tipoAsistencia, asistencia) {
    const control = asistencia.tipoID;
    asistencia.tipoID = tipoAsistencia.id;
    this.asistenciaService.setEstadoAsistenciaMateria(asistencia).subscribe(res => {
      const currAsistencia = this.asistenciaService.extractData(res);
      asistencia.id = currAsistencia.id;
      this.cdRef.markForCheck();
      this.snackBar.open(
        `Asistencia actualizada`,
        null,
        { duration: 2500 }
      );
    }, err => {
      asistencia.tipoID = control;
      this.cdRef.markForCheck();
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `Se ha presentado un error actualizando la asistencia. <br> Código de error: ${err.statusText}`
      });
    }, () => {
    });
  }

  detallesAsistencia(fila, contenedor) {
    if (!d3.select(`.data-asistencia-${fila.alumno.id}`).empty()) {
      d3.select(`.data-asistencia-${fila.alumno.id}`).remove();
      return;
    }
    d3.select('.detail-container').remove();

    const tipDiv = d3.select(contenedor).append('div')
      .attr('class', `detail-container mat-elevation-z24 data-asistencia-${fila.alumno.id}`);
    // Agregamos el header
    tipDiv
      .append('div')
      .attr('class', 'flex-wrap')
      .html('<div class="inline-flex">Ausencias</div><div class="inline-flex">Retardos</div><div class="inline-flex">Total</div>');
    tipDiv.append('div').attr('class', 'loading').html('Cargando datos...');

    this.asistenciaService.getDetailAcumulada(fila.alumno.id, this.mcpID).subscribe(res => {
      tipDiv.select('.loading').remove();
      this.asistenciaService.setDetailAcumuladaHTML(this.asistenciaService.extractData(res), tipDiv);
    });
  }

  setTareaState(evt, fila) {
    let obj = fila.faltaTarea;
    if (!obj) {
      obj = {
        id: 0,
        faltaTarea: evt.checked,
        materiaCursoPeriodoID: this.mcpID,
        alumnoID: fila.alumno.id,
        fecha: this.fechaSeleccionada
      };
    }
    obj.faltaTarea = evt.checked;
    this.asistenciaService.setTarea(obj).subscribe(res => {
      if (evt.checked) {
        fila.faltaTarea = this.asistenciaService.extractData(res);
        fila.faltaTareaAcumula++;
      } else {
        fila.faltaTarea = null;
        fila.faltaTareaAcumula--;
      }
      this.cdRef.markForCheck();
    }, err => {

    });
  }

  openComments(asistencia) {
    const dialogRef = this.dialog.open(SingleCommentComponent, { data: { comentario: asistencia.comentario }, disableClose: true, maxWidth: '70vm' });

    dialogRef.afterClosed().subscribe(data => {
      if (!data) {
        return false;
      }
      asistencia.comentario = data;
      this.asistenciaService.setEstadoAsistenciaMateria(asistencia).subscribe(res => {
        this.snackBar.open(
          `Comentario guardado.`,
          null,
          { duration: 2500 }
        );
        this.cdRef.markForCheck();
      }, err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `Se ha presentado un error. <br> Código de error: ${err.statusText}`
        });
      }, () => {
      });
    });
  }

  setComment(comment, fila) {
    if (this.commentSub) {
      this.commentSub.unsubscribe();
    }
    fila.faltaTarea.comentario = comment;
    this.commentSub = this.asistenciaService.setTarea(fila.faltaTarea).subscribe(res => {
      fila.faltaTarea = this.asistenciaService.extractData(res);
    }, err => {

    });
  }

  getDetalleTareas(alumno, contenedor) {
    if (!d3.select(`.data-tarea-${alumno.id}`).empty()) {
      d3.select(`.data-tarea-${alumno.id}`).remove();
      return;
    }
    d3.select('.detail-container').remove();

    const detailDiv = d3.select(contenedor).append('div')
      .attr('class', `detail-container mat-elevation-z24 data-tarea-${alumno.id}`);

    detailDiv.append('div').append('h5').text('Faltas de tareas');

    detailDiv.append('div').attr('class', 'loading').html('Cargando datos...');
    this.asistenciaService.getDetailTareasAcumuladas(alumno.id, this.mcpID).subscribe(res => {
      detailDiv.select('.loading').remove();
      this.asistenciaService.setTareasDetailHTML(this.asistenciaService.extractData(res)[0], detailDiv);
    }, err => {

    });
  }

  toggleRowsState(evt) {
    this.rowStateSubject.next(evt.checked ? { state: 'expanded', label: 'Contraer' } : { state: 'collapsed', label: 'Expandir' });
  }

  existsAssistance(assistences) {
    return assistences.filter(assistance => assistance.id > 0 && assistance.id !== 13).length > 0;
  }
}
